import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import { useLocation, useNavigate } from "react-router-dom";
import { getPermissions } from "../rbac/hasAccess";
import { submitSiteDelete } from "../../utils/commonComponent/delete";
import ListSearchSection from "../../utils/commonComponent/Custom/ListSearchSection";
import { AddButton } from "../../utils/commonComponent/Custom/Button";
import { fetchQuery } from "../../utils/commonComponent/fetched";
import axiosWithToken from "../../utils/commonComponent/axiosTokenConfig";
import { toast } from "react-toastify";
import { BASE_URL, MAX_COLS } from "../../global";
import { Autocomplete, Box, Button, Modal, TextField } from "@mui/material";

const fields = [
  { value: "materialName", label: "Material Name" },
  { value: "testName", label: "Test Name" },
  { value: "testMethod", label: "Test Method" },
  { value: "tableName", label: "Table Name" },
];

const TemplateList = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const permissions = getPermissions(props.moduleId);
  const handleEdit = (row) => navigate(`/master/editTemplate/${row.id}`);
  const handleDelete = async (id) => {
    const url = BASE_URL;
    const idString = (Array.isArray(id) ? id : [id]).join(',');
    const confirmed = window.confirm("Are you sure you want to delete this ?");
    if (!confirmed) return;

    try {
      await axiosWithToken.post(url + 'dynamic', {
        query: `UPDATE observationTemplates SET status = -1 WHERE id IN (${idString});`
      });
    } catch (error) {
      console.log("err", error);
    }

    try {
      await axiosWithToken.post(url + 'dynamic', {
        query: `UPDATE certificateTemplates SET status = -1 WHERE id IN (${idString});`
      });
      toast("Template table deleted!");
    } catch (error) {
      console.log("err", error);
    }

    window.location.reload();
  };

  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "testName");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true" || false);
   // Pagination
  const [currentPage, setCurrentPage] = useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));
  const [templateList, setTemplateList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);

  // modal  
  const [open, setOpen] = React.useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [materialId, setMaterialId] = useState(null);
  const [testId, setTestId] = useState(null);
  const [materialTestingsArray, setMaterialTestingsArray] = useState([]);
  const [materialScopeArray, setMaterialScopeArray] = React.useState([]);  
  const handleClose = () => {
    setSelectedRow(null);
    setMaterialId(null);
    setTestId(null);
    setOpen(false);
  };
  const handleOpenModal = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };

  const getQuery = (count = false) => {
    let whereConditions = "WHERE ot.status = 1 ";
    let pagination_settings = "";

    if (searchBy && searchKey.trim()) {
      const colName = {
        tableName: "tableName",
        materialName: "materialName",
        testName: "testName",
        testMethod: "testMethod",
      }[searchBy];
      whereConditions += ` And LOWER(${colName}) LIKE LOWER('%${searchKey}%')`;
    }

    if (count) {
      return `SELECT COUNT(*) AS no_of_rows FROM observationTemplates ot LEFT JOIN materialTestings mt ON ot.testId = mt.id LEFT JOIN materialScope ms ON ot.materialId = ms.id ${whereConditions};`;
    }

    // Add pagination to query
    const offset = currentPage * rowsPerPage;
    pagination_settings = `LIMIT ${rowsPerPage} OFFSET ${offset}`;

    return `SELECT ot.*, mt.testName AS testName, mt.testMethod AS testMethod, ms.MaterialName AS materialName FROM observationTemplates ot LEFT JOIN materialTestings mt ON ot.testId = mt.id LEFT JOIN materialScope ms ON ot.materialId = ms.id ${whereConditions}  ORDER BY id DESC ${pagination_settings}`;
  };

  const fetchData = async () => {
    try {
      const countQuery = getQuery(true);
      const countResult = await fetchQuery(countQuery);
      setTotalRecords(countResult[0]?.no_of_rows || 0);

      const query = getQuery();
      const result = await fetchQuery(query);
      setTemplateList(result);
    } catch (error) {
      console.error("Error fetching template data:", error);
    }
  };

  const handleSearch = () => {
    if (!searchBy || !searchKey.trim()) {
      alert("Please select a search field and enter a search value.");
      return;
    }
    fetchData();
    setSearched(true);
    // Save search state to sessionStorage
    sessionStorage.setItem("searchBy", searchBy);
    sessionStorage.setItem("searchKey", searchKey);
    sessionStorage.setItem("searched", "true");
    sessionStorage.setItem("currentPath", location.pathname);
    sessionStorage.setItem("ListPageCount", 0);
    setCurrentPage(0);
  };

  const clearSearch = () => {
    setSearched(false);
    setSearchBy("testName");
    setSearchKey("");
     // Clear all employee list session storage
    sessionStorage.removeItem("ListPageCount");
    sessionStorage.removeItem("ListRowsPerPage");
    sessionStorage.removeItem("searchBy");
    sessionStorage.removeItem("searchKey");
    sessionStorage.removeItem("searched");
    setCurrentPage(0);
  };

  const getMaterialScopeList = () => {
    axiosWithToken
      .get(BASE_URL + "materialScope?_where=(status,eq,1)")
      .then((res) => setMaterialScopeArray(res.data))
      .catch(() => toast.error("Error loading materials!"));
  };

  const getMaterialTestingsList = async () => {
    if (!materialId) return;
    try {
      const sqlQuery = `SELECT id, testName, materialId FROM materialTestings WHERE status = 1 AND materialId = ${materialId}`;
      const res = await fetchQuery(sqlQuery);
      setMaterialTestingsArray(res || []);
    } catch (error) {
      console.error("Error fetching test data:", error);
    }
  };

   useEffect(() => {
    if (materialId) getMaterialTestingsList();
  }, [materialId]);

  const handleCopy = async () => {
    if (!selectedRow) return;
    if (!materialId || !testId) {
      toast.error("Please select both Material and Test!");
      return;
    }
    try {
      // Fetch both observationTemplates and certificateTemplates
      const [obsRes, certRes] = await Promise.all([
        fetchQuery(`SELECT * FROM observationTemplates WHERE id = ${selectedRow.id}`),
        fetchQuery(`SELECT * FROM certificateTemplates WHERE id = ${selectedRow.id}`),
      ]);

      if (!obsRes?.length) {
        toast.error("Template not found!");
        return;
      }

      const obs = obsRes[0];
      const cert = certRes[0] || {};

      // Prepare observation POST 
      const obsData = {
        tableName: `${obs.tableName}_Copy`,
        tableInstructions: obs.tableInstructions,
        materialId: materialId,
        testId: testId,
        defaultConfiguration: obs.defaultConfiguration,
        conditionFormatting: obs.conditionFormatting,
        customPrecision: obs.customPrecision,
        isUncertainty: obs.isUncertainty,
        isComplianceStatus: obs.isComplianceStatus,
      };

      // Copy dynamic c1...cN columns
      for (let i = 1; i <= MAX_COLS; i++) {
        const key = "c" + i;
        if (obs[key] !== undefined) obsData[key] = obs[key];
      }

      //  POST to create new observation template
      await axiosWithToken.post(BASE_URL + "observationTemplates", obsData);

      //  If a linked certificate template exists, copy that too
      if (cert && Object.keys(cert).length > 0) {
        const certData = {
          tableName: `${cert.tableName || obs.tableName}_Copy`,
          materialId: materialId,
          testId: testId,
          defaultConfiguration: cert.defaultConfiguration,
          isUncertainty: cert.isUncertainty,
          status: cert.status,
          isComplianceStatus: cert.isComplianceStatus,
        };

        for (let i = 1; i <= 60; i++) {
          const key = "c" + i;
          if (cert[key] !== undefined) certData[key] = cert[key];
        }

        await axiosWithToken.post(BASE_URL + "certificateTemplates", certData);
      }

      toast.success("Template copied successfully!");

      //  Refresh the table data
      fetchData();
      handleClose();
    } catch (error) {
      console.error("Error copying template:", error);
    }
  };

  useEffect(() => {
    fetchData();
    getMaterialScopeList();
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    if (searched == false) {
      fetchData();
    }
  }, [searched]);

  // Pagination logic
  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  const handleChangePage = (newPage) => {
    if (newPage >= 0 && newPage < totalPages) {
      setCurrentPage(newPage);
      sessionStorage.setItem("currentPath", location.pathname);
      sessionStorage.setItem("ListPageCount", newPage);
    }
  };

  const handleChangeRowsPerPage = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
    sessionStorage.setItem("ListRowsPerPage", e.target.value);
    sessionStorage.setItem("ListPageCount", 0);
  };

  return (
    <>
      {(permissions.create || permissions.allAccess) && (
        <AddButton
          id="btn-add-outline"
          to="/master/editTemplate/0"
          label="Add Template"
          icon={<AddIcon fontSize="small" />}
        />
      )}

      <ListSearchSection
        fields={fields}
        onSearch={handleSearch}
        searchKey={searchKey}
        setSearchKey={setSearchKey}
        searchBy={searchBy}
        setSearchBy={setSearchBy}
        clearSearch={clearSearch}
        searched={searched}
        setSearched={setSearched}
      />

      <div className="w-full border rounded-md shadow mt-3">
        <div className="overflow-y-auto h-auto max-h-[400px]">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="sticky top-0 bg-blue-50 text-xs uppercase font-medium text-gray-600 z-10">
              <tr>
                <th className="px-4 py-3 text-center">Sr. No.</th>
                <th className="px-4 py-3 text-center">Material Name</th>
                <th className="px-4 py-3 text-center">Test Name</th>
                <th className="px-4 py-3 text-center">Test Method</th>
                <th className="px-4 py-3 text-center">Table Name</th>
                {(permissions.edit ||
                  permissions.copy ||
                  permissions.delete ||
                  permissions.allAccess) && (
                    <th className="px-4 py-3 text-center">Actions</th>
                  )}
              </tr>
            </thead>


            <tbody className="divide-y divide-gray-200">
              {templateList.length > 0 ? (
                templateList.map((row, index) => (
                  <tr key={row.id} className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-center">
                     {currentPage * rowsPerPage + index + 1}
                    </td>
                    <td className="px-4 py-3 text-center">{row.materialName}</td>
                    <td className="px-4 py-3 text-center">{row.testName}</td>
                    <td className="px-4 py-3 text-center">{row.testMethod}</td>
                    <td className="px-4 py-3 text-center">{row.tableName}</td>

                    {(permissions.edit ||
                      permissions.delete ||
                      permissions.allAccess) && (
                        <td className="px-4 py-2 text-center">
                          <div className="flex justify-center gap-3">
                            {(permissions.edit || permissions.allAccess) && (
                              <button
                                onClick={() => handleEdit(row)}
                                className="text-blue-600 hover:text-blue-800"
                                title="Edit"
                              >
                                <EditIcon fontSize="small" />
                              </button>
                            )}
                            {(permissions.copy || permissions.allAccess) && (
                              <button
                                onClick={() => handleOpenModal(row)}
                                className="text-blue-600 hover:text-blue-800"
                                title="Edit"
                              >
                                <ContentCopyIcon fontSize="small" />
                              </button>
                            )}
                            {(permissions.delete ||
                              permissions.allAccess) && (
                                <button
                                  onClick={() => handleDelete(row.id)}
                                  className="text-blue-600 hover:text-blue-800"
                                  title="Delete"
                                >
                                  <DeleteIcon fontSize="small" />
                                </button>
                              )}
                          </div>
                        </td>
                      )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={
                      (permissions.edit || permissions.delete ? 5 : 4)
                    }
                    className="text-center py-4 text-gray-500"
                  >
                    No data available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination Footer */}
        <div className="flex items-center justify-between px-4 py-2 bg-blue-50 text-sm border-t">
          <div className="flex items-center gap-2">
            <span>Rows per page:</span>
            <select
              value={rowsPerPage}
              onChange={handleChangeRowsPerPage}
              className="border rounded px-2 py-1 text-sm"
            >
              {[30, 50, 100].map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center gap-2">
            <span className="text-gray-600">
              {totalRecords === 0
                ? "0–0 of 0"
                : `${currentPage * rowsPerPage + 1}–${Math.min(
                  (currentPage + 1) * rowsPerPage,
                  totalRecords
                )} of ${totalRecords}`}
            </span>
            <button
              onClick={() => handleChangePage(0)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <FirstPageIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage - 1)}
              disabled={currentPage === 0}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowLeftIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(currentPage + 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-1 disabled:opacity-50"
            >
              <KeyboardArrowRightIcon fontSize="small" />
            </button>
            <button
              onClick={() => handleChangePage(totalPages - 1)}
              disabled={currentPage >= totalPages - 1}
              className="p-1 disabled:opacity-50"
            >
              <LastPageIcon fontSize="small" />
            </button>
          </div>
        </div>
      </div>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "50%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <h2 className="text-lg font-semibold mb-4">Select Material & Testing</h2>

          <div className="flex flex-wrap md:flex-nowrap gap-4 mb-4">
            <div className="w-full md:w-1/3">
              <Autocomplete
                size="small"
                options={materialScopeArray.map((m) => ({
                  label: `${m.id}, ${m.MaterialName}`,
                  id: m.id,
                }))}
                onChange={(e, val) => setMaterialId(val ? val.id : null)}
                renderInput={(params) => (
                  <TextField {...params} label="Material" className="w-full" />
                )}
              />
            </div>

            <div className="w-full md:w-1/3">
              <Autocomplete
                size="small"
                options={materialTestingsArray}
                value={materialTestingsArray.find((opt) => opt.id == testId) || null}
                getOptionLabel={(option) => option?.testName || ""}
                onChange={(_, value) => setTestId(value ? value.id : null)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField {...params} label="Testing" className="w-full" />
                )}
              />
            </div>

            <div className="w-full md:w-1/3 flex items-center">
              <Button
                variant="contained"
                color="primary"
                size="small"
                className="w-full md:w-auto"
                onClick={handleCopy}
              >
                Save
              </Button>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default TemplateList;
